import { render, staticRenderFns } from "./ClosedTab.vue?vue&type=template&id=fd90c7f4"
import script from "./ClosedTab.vue?vue&type=script&lang=js"
export * from "./ClosedTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports